module.exports = __webpack_public_path__ + "img/cabinet_fault.bf750bf5.svg";